import { Snackbar, Alert, Slide } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";

function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
}

function ConnectionStatus({ isOnline }) {
    return (
        <Snackbar
            open={!isOnline}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            TransitionComponent={SlideTransition}
            sx={{
                "& .MuiSnackbarContent-root": {
                    minWidth: "auto",
                },
            }}
        >
            <Alert
                severity="error"
                variant="filled"
                icon={<WifiOffIcon />}
                sx={{
                    width: "100%",
                    fontWeight: "bold",
                    fontSize: "0.95rem",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                }}
            >
                No internet connection. Please check your network.
            </Alert>
        </Snackbar>
    );
}

export default ConnectionStatus;
